export const baseFont = 'Swiss721BTRegular';
export const boldFont = 'Swiss721BTBold';
export const lightFont = 'Swiss721LtBTLight';
export const bodyFont = `'Lora', ${baseFont}`;
export const headerFont = `'Montserrat', ${baseFont}`;



// WEBPACK FOOTER //
// ./src/utils/fonts.js